/* unplugin-vue-components disabled */import script from "./userConsoleLayout.vue?vue&type=script&setup=true&lang=js"
export * from "./userConsoleLayout.vue?vue&type=script&setup=true&lang=js"

import "./userConsoleLayout.vue?vue&type=style&index=0&id=70423962&lang=less&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-70423962"]])

export default __exports__